module.exports = __webpack_public_path__ + "static/6-2f057f598c08177a1428c12e722c2953.jpg";